export default __webpack_public_path__ + "media/src/assets/images/driver_icon-475293c002218d63c99854d8d03baf75.svg";